import {NgModule} from '@angular/core';
import { GetByIdPipe } from './getById.pipe';

import { StringFormatPipe } from './stringFormat.pipe';

@NgModule({
    declarations: [
        StringFormatPipe,
        GetByIdPipe
    ],
    imports     : [],
    exports     : [
        StringFormatPipe,
        GetByIdPipe
    ]
})
export class FusePipesModule
{
}
